import { useMemo, useState } from 'react';
import { MeasurementRange } from '../../common/chart/types/types';
import type { ProviderCommonProps } from '../../../types/provider.types';
import type { ClusterDataContextType } from './types';
import { ClusterDataContext } from './context';
import { getDateRangeByPage } from '../../common/chart/utils/date-range';
import { MeterTypeInternal } from '../../../api/openapi';

export const ClusterDataProvider = ({ children }: ProviderCommonProps) => {
  const [selectedRange, updateSelectedRange] = useState<MeasurementRange>(MeasurementRange.DayInHours);
  const [meterType, setMeterType] = useState<MeterTypeInternal>(MeterTypeInternal.Standalone);
  const [page, setPage] = useState(0);
  const [selectedInstallationIds, setSelectedInstallationIds] = useState<string[]>([]);

  const fromTo = useMemo(() => getDateRangeByPage(selectedRange, page), [selectedRange, page]);

  const setSelectedRange = (range: MeasurementRange) => {
    updateSelectedRange(range);
    setPage(0);
  };

  const value: ClusterDataContextType = {
    selectedRange,
    setSelectedRange,
    page,
    setPage,
    fromTo,
    meterType,
    setMeterType,
    selectedInstallationIds,
    setSelectedInstallationIds,
  };

  return <ClusterDataContext.Provider value={value}>{children}</ClusterDataContext.Provider>;
};
